<template>
    <div class="login-screen">
        <b-row >
            <h5 class="login-title">{{ $t('message.login') }}</h5>
            <b-icon class="routes-back-arrow" icon="x" variant="black" font-scale="0.5" @click="handleClose"></b-icon>
        </b-row>
        <div class="phone-number-input">
            <Input v-model="mobileNumber" input_type="number" :label_form="$t('message.phoneNumber')"/>
        </div>
        <div class="reenter-mobile-input">
            <Input v-model="reEnterMobileNumber" input_type="number" :label_form="$t('message.reEnterPhoneNumber')"/>
            <b-row class="reenter-row">
                <b-form-group class="reenter-form">
                <p v-if="mobileNumberValidation" class="text-danger reenter-p-text">
                   {{ $t('message.phoneNumberNotMatched') }} </p>
                </b-form-group>
            </b-row>
        </div>
        <div class="place-bid-btn place-bid-btn-align">
            <b-button :disabled="isdisabled" class="ft-btn" block variant="dark"
                    @click="handleLogin">
            {{ $t('message.loginAndPlaceBid') }}
            </b-button>
        </div>
    </div>
</template>
<script>
import Input from '../components/Input.vue'
export default {
    components: {
        Input,
    },
    data() {
        return {
            mobileNumber:'',
            reEnterMobileNumber:''
        }
    },
    updated() {
        this.mobileNumber = this.mobileNumber.slice(0, 10);
        this.reEnterMobileNumber = this.reEnterMobileNumber.slice(0, 10);
    },
    methods:{
        handleLogin(){
           // const status = 'fail'
           // const id = 'KOwurrTa'
            this.$emit('submit-login', this.mobileNumber)
        },
        handleClose(){
            this.$emit('handle-close');
        }
    },
    computed: {
        mobileNumberValidation: function () {
            return this.reEnterMobileNumber!==''&& this.mobileNumber!==this.reEnterMobileNumber
        },
        isdisabled: function(){
            return this.mobileNumber==''||this.reEnterMobileNumber==''||this.mobileNumber!==this.reEnterMobileNumber
        }
    }
}
</script>
<style >
.login-screen{
    width:100%;
}
.login-title{
    margin-left:10%;
    margin-top:10px
}
.phone-number-input{
    margin-left:10%;
    margin-right: 10%;
    margin-top:30%;
}
.reenter-mobile-input{
    margin-left:10%;
    margin-top:5%;
    margin-right: 10%;
}
.reenter-row{
    width: 100%
}
.reenter-form{
    width: 100%;
     margin-bottom: 1rem
}
.reenter-p-text{
    margin-bottom: 0
}
.place-bid-btn-align{
    margin-left:10%;
    margin-right:10%;
    margin-top:10%;
}
.routes-back-arrow{
    width:20px;
    height:20px;
    margin-top:11px;
    margin-left:60%;
    stroke:#707070;
    stroke-width:1px;
}
</style>
